<div class="forms-page records-page">
  <div class="details-tab-surface forms-page-surface">
    <div class="records-page__hero forms-page-hero">
      <div class="records-page__hero-primary">
        <div class="records-page__hero-headline">
          <span class="records-page__hero-eyebrow">{{ 'FORMS' | translate }}</span>
          <h3 class="records-page__hero-title">{{ 'TEAM_FORMS' | translate }}</h3>
        </div>
      </div>
    </div>
    <div class="forms-page__content">
      <div class="forms-page__legacy-link">
        <a class="forms-page__legacy-link-anchor" target="_blank" [href]="instance.is('prspr') ? 'https://reach.marketing/prspr-forms/' : 'https://reach.marketing/forms/'">{{ 'HERE_IS_THE_OLD_FORMS_PAGE' | translate }}</a>
      </div>

      <div class="row row-gap-4 d-flex align-items-stretch forms-page__grid">
        <div class="col-12 col-xl-4">
          <div class="card details-card forms-page__card">
            <h5 class="card-title">{{ 'FORMS' | translate }}</h5>
            <div class="card-body forms-page__card-body">
              <div class="forms-page__actions">
                <button class="blue-button forms-page__action" type="button" (click)="openChangeDmsModal()">{{ 'CHANGE_DMS' | translate }}</button>
                <button class="blue-button forms-page__action" type="button" (click)="openLpRequestModal()">{{ 'LP_REQUEST' | translate }}</button>
                <button class="blue-button forms-page__action" type="button" (click)="openTechRequestModal()">{{ 'TECH_REQUEST' | translate }}</button>
                <button class="blue-button forms-page__action" type="button" (click)="openCreativeRequestModal()">{{ 'COPY_CREATIVE_REQUEST' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-4">
          <div class="card details-card forms-page__card">
            <h5 class="card-title">{{ 'ACTIONS' | translate }}</h5>
            <div class="card-body forms-page__card-body">
              <div class="forms-page__actions">
                <button class="red-button forms-page__action" type="button" (click)="openSendEmailModal()">{{ 'SEND_EMAIL' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
